const th = {
  launchKicker: "ลงทะเบียนก่อนเปิดตัว",
  launchTitle: "แอปฉบับสมบูรณ์จะเปิดตัวภายในวันที่ 1 กุมภาพันธ์ 2027",
  launchBody: "ตอนนี้เรากำลังทดสอบแอปและสรุปข้อตกลงความร่วมมือ นี่คือเวลาที่ธุรกิจ ผู้สนับสนุน และเทศบาลจะลงทะเบียน — และรับส่วนลด 50% ในฐานะพันธมิตรเปิดตัว",
  launchCta: "ลงทะเบียนเลย",
  testApp: "ลองแอปทดสอบ",
  bandKicker: "สำหรับธุรกิจ",
  bandTitle: "เพิ่มโทรลล์ของคุณเอง — ลด 50% สำหรับพันธมิตรเปิดตัว",
  bandBody: "โรงแรม คาเฟ่ ซาวน่า ร้านค้า และเทศบาลลงทะเบียนได้ตั้งแต่ตอนนี้ เพื่อให้โทรลล์พร้อมเมื่อแอปเปิดตัว",
  bandCta: "ลงทะเบียนเป็นพันธมิตร",
  kicker: "ลงทะเบียน",
  title: "วางโทรลล์ของคุณบนแผนที่",
  lead: "บอกเราว่าคุณเป็นใคร เลือกแพ็กเกจ แล้ววางโทรลล์บนแผนที่ คุณจ่ายผ่าน Vipps และเราจะเตรียมโทรลล์ของคุณให้พร้อมสำหรับการเปิดตัว",
  role: "คุณคือใคร?",
  rolePh: "เลือก…",
  roles: { homeowner: "เจ้าของบ้านหรือเจ้าบ้านส่วนตัว", municipality: "เทศบาล ภูมิภาค หรือการท่องเที่ยว", sponsor: "ผู้สนับสนุน", other: "อื่นๆ" },
  firstName: "ชื่อ",
  lastName: "นามสกุล",
  company: "บริษัทหรือองค์กร",
  optional: "ไม่บังคับ",
  email: "อีเมล",
  phone: "โทรศัพท์",
  website: "เว็บไซต์",
  package: "แพ็กเกจ",
  mapTitle: "คุณอยากวางโทรลล์ไว้ที่ไหน?",
  mapHint: "ค้นหาที่อยู่ของคุณ แล้วแตะแผนที่เพื่อวางโทรลล์ ลากหมุดเพื่อย้ายตำแหน่ง",
  search: "ค้นหาที่อยู่หรือสถานที่ในนอร์เวย์",
  searchBtn: "ค้นหา",
  noResults: "ไม่พบสถานที่ ลองค้นหาคำอื่น",
  placed: "วางโทรลล์แล้ว {n} จาก {max} ตัว",
  full: "วางโทรลล์ครบแล้ว — ลบหนึ่งตัวเพื่อย้าย หรือเลือกแพ็กเกจที่ใหญ่ขึ้น",
  noPackage: "เลือกแพ็กเกจก่อน แล้วจะเห็นว่าวางโทรลล์ได้กี่ตัว",
  outside: "วางโทรลล์ได้เฉพาะในนอร์เวย์เท่านั้น",
  pin: "โทรลล์ {n}",
  remove: "ลบ",
  message: "มีอะไรที่เราควรรู้ไหม?",
  messagePh: "เวลาเปิดทำการ ไอเดียโทรลล์ คำถาม…",
  consent: "ฉันยินยอมให้ Trollfossjakten เก็บข้อมูลเหล่านี้เพื่อดำเนินการลงทะเบียนของฉัน ดู{privacy}",
  submit: "ลงทะเบียนและไปที่การชำระเงิน",
  sending: "กำลังส่ง…",
  summary: "คำสั่งซื้อของคุณ",
  pickPackage: "เลือกแพ็กเกจเพื่อดูราคา",
  payNote: "คุณจ่ายผ่าน Vipps หลังลงทะเบียน ราคาเปิดตัว: ลด 50% ในปีแรก",
  errors: {
    phone: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง (ตัวเลข + และเว้นวรรค)",
    required: "กรุณากรอกช่องที่จำเป็นให้ครบ",
    email: "กรุณากรอกอีเมลที่ถูกต้อง",
    pins: "กรุณาวางโทรลล์บนแผนที่อย่างน้อยหนึ่งตัว",
    consent: "กรุณายอมรับวิธีที่เราเก็บข้อมูลของคุณ",
    tooMany: "ลงทะเบียนจากอุปกรณ์นี้มากเกินไป โปรดลองใหม่ภายหลัง",
    generic: "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
  },
  doneKicker: "ขอบคุณ!",
  doneTitle: "คุณลงทะเบียนเรียบร้อยแล้ว {name}",
  doneBody: "หมายเลขคำสั่งซื้อของคุณคือ {ref} เราได้ส่งสำเนาไปที่ {email} แล้ว ชำระผ่าน Vipps เพื่อรับราคาเปิดตัว",
  doneBodyNoMail: "หมายเลขคำสั่งซื้อของคุณคือ {ref} โปรดเก็บไว้ — ชำระผ่าน Vipps เพื่อรับราคาเปิดตัว",
  another: "ลงทะเบียนสถานที่อื่น",
  payTitle: "จ่ายผ่าน Vipps",
  number: "หมายเลข Vipps",
  amount: "จำนวนเงิน",
  ref: "หมายเลขคำสั่งซื้อ",
  copy: "คัดลอก",
  copied: "คัดลอกแล้ว",
  exVat: "ราคาไม่รวม VAT",
  vat: "VAT 25%",
  total: "ยอดที่ต้องชำระ",
  steps: ["เปิด Vipps แล้วเลือกส่งเงิน", "ใส่หมายเลข {number}", "ใส่จำนวนเงิน {amount} kr", "ในข้อความ ให้ใส่หมายเลขคำสั่งซื้อ {ref}"],
  invoice: "อยากได้ใบแจ้งหนี้ใช่ไหม? ตอบกลับอีเมลยืนยัน แล้วเราจะส่งให้",
  host: { name: "จุดเจ้าบ้าน", for: "คาเฟ่ ฟาร์ม กระท่อม B&B ซาวน่า หรือร้านค้าที่ต้อนรับนักล่าโทรลล์และรับ Troll Kroner", free: "ฟรี" },
  mapTitleHost: "สถานที่ของคุณอยู่ที่ไหน — หรือคุณวางแผนจะเปิดที่ไหน?",
  mapHintHost: "ค้นหาที่อยู่ของคุณ แล้วแตะแผนที่เพื่อปักหมุด ลากหมุดเพื่อย้ายตำแหน่ง",
  placePin: "สถานที่ของคุณ",
  placedHost: "ปักหมุดแล้ว {n} จาก 1 แห่ง",
  fullHost: "ปักหมุดสถานที่ของคุณแล้ว — ลากหมุดเพื่อย้าย หรือลบออกก่อน",
  placeTitle: "สถานที่ของคุณ",
  placeBody: "บอกนักล่าโทรลล์ว่าคุณมีอะไรให้บริการ แล้วติ๊กทุกอย่างที่คุณมี",
  offer: "คุณจะให้บริการอะไร?",
  offerPh: "เช่น กาแฟและวาฟเฟิล ซาวน่า ห้องพักค้างคืน",
  amenitiesTitle: "คุณมีอะไรบ้าง? ติ๊กทุกข้อที่ตรง",
  amenities: { coffee: "กาแฟ", tea: "ชา", snacks: "ขนม", restaurant: "ร้านอาหาร", conversations: "พูดคุย", phone_charging: "ชาร์จโทรศัพท์", bike_charging: "ชาร์จจักรยานไฟฟ้า", car_charging: "ชาร์จรถยนต์ไฟฟ้า", shower: "ห้องอาบน้ำ", room: "ห้องพัก", sauna: "ซาวน่า", bnb: "Bed & breakfast", hotel: "โรงแรม", camping: "ตั้งแคมป์", parking: "ที่จอดรถ", toilet: "ห้องน้ำ", wifi: "Wifi" },
  hostNote: "การเป็นเจ้าบ้านฟรี — ไม่ต้องชำระเงินและไม่มีค่าสมัคร เราจะตรวจสอบข้อมูลและเพิ่มสถานที่ของคุณลงในแผนที่",
  submitHost: "ลงทะเบียนเป็นเจ้าบ้าน",
  offerError: "โปรดบอกเราว่าคุณจะให้บริการอะไร",
  hostDoneTitle: "{name} คุณลงทะเบียนเป็นเจ้าบ้านแล้ว",
  hostDoneBody: "หมายเลขอ้างอิงของคุณคือ {ref} เราส่งสำเนาไปที่ {email} แล้ว เราจะตรวจสอบข้อมูลและเพิ่มสถานที่ของคุณลงในแผนที่",
  hostDoneBodyNoMail: "หมายเลขอ้างอิงของคุณคือ {ref} โปรดเก็บไว้ — เราจะตรวจสอบข้อมูลและเพิ่มสถานที่ของคุณลงในแผนที่",
  hostNextTitle: "ขั้นตอนถัดไป",
  hostNext: ["ดาวน์โหลดแอปและลงชื่อเข้าใช้ด้วยอีเมลเดียวกัน", "ไปที่ โปรไฟล์ → เป็นเจ้าบ้าน เพื่อเริ่มรับ Troll Kroner", "สแกน QR ชำระเงินของแขก — แอปจะคำนวณยอดที่เหลือให้"],
  hostGetApp: "ดาวน์โหลดแอป",
};

export default th;
